<template>
 <button v-if="totalCartItems>0"
            class="h-16 w-full bg-namasteBlue text-white rounded-md my-2"
      >
        <div class="flex justify-center space-x-6 text-warmGray-50 rounded-md
        font-seminbod text-xl py-2">
           <btn class="my-auto mr-2"
              :cartIcon="true" :totalCartItems="totalCartItems" :hasProduct="true"
             >
          </btn>
          <span class="my-auto border-l-2  px-3 text-warmGray-50 text-xl font-semibold">
             <!-- Gesammt: {{ numeralFormat(cartTotal+lieferkosten, '0,00[.]00 $') }} -->
              Gesammt: {{ numeralFormat(getTotalCost, '0,00[.]00 $') }}
          </span>
        </div>
      </button>

</template>
<script>
import Btn from '@/components/Btn'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      totalCartItems: 'getTotalCartItems',
      cartTotal: 'getFormCartTotal',
      lieferkosten: 'getLieferKosten',
      getTotalCost: 'getGesammtKosten'
    })
  },
  components: {
    Btn
  },
  methods: {
    // ...mapActions({

    // }),
    // setTotalCost () {

    // }

  }
}
</script>
